import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../environments/environment';
import {AuthService} from './auth/auth.service';
import {Subject} from 'rxjs';

declare var require: any;

const AES256 = require('aes-everywhere');

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {

    tokenTrigger = new Subject();

    constructor(private http: HttpClient, private  auth: AuthService) {
    }

    generateToken(flag) {
        /** Managing flag to trigger token expiration and refresh token */
        this.http.post('auth/Token/GetAPIAccessKey', {
            'AccessKey': AES256.encrypt('SWAS@AK6261#', environment.KBAESKEY), //'SWAS@AK6261#',
            'AccessSecret': AES256.encrypt(environment.searchUrl.includes('staging') ? 'BA2C0CE3-5FAC-4780-AE8D-797B96511F1B' : 'A2B57021-639E-47E2-85D8-6F84A2489CC6', environment.KBAESKEY),
            'GenerationSource': 'WEB',
            'IPAddress': '183.182.84.122',
            'IMEINumber': '',
            'AppVersion': 'RP_WEB_1.0',
            'DeviceId': '12345',
            'DeviceVersion': '',
            'BrowserName': 'chrome',
            'WebUniqueId': '12345'
        }).subscribe(
            (res: any) => {
                localStorage.setItem('search_token', res.Result.Data['AccessToken']);
                if (flag) {
                    /** So if flag will be one mean we are refreshing the token
                     * so in this case we need to pass trigger to call search api
                     * again with new token*/
                    this.tokenTrigger.next();
                }
            },
            error => {
            }
        );
    }

    getheader() {
        const httpOptions = {
            headers: new HttpHeaders({
                'Authorization': 'Bearer ' + localStorage.getItem('search_token'),
                'AppId': environment.AppID,
                'version': '1'
            })
        };
        return httpOptions;
    }

    decryptService(data) {
        const decrypted = AES256.decrypt(data, environment.AESKeyTradinGo);
        return JSON.parse(decrypted);
    }

    encryptService(data) {
        const user = JSON.stringify(data);
        const encrypt = AES256.encrypt(user, environment.AESKeyTradinGo);
        return encrypt;
    }

    isLoggedIn() {
        if (sessionStorage.getItem('isLoggedIn') == null) {
            return false;
        }
        return this.decryptService(sessionStorage.getItem('isLoggedIn'));
    }
}
